module.exports = __webpack_public_path__ + "img/Marquee-08.5fa113dc.jpg";